import React, { useCallback } from 'react';

import { HelpTypes } from '@pharmaplan/common';

import { useAppDispatch } from '../../useAppDispatch';
import { setDialog } from '../../../reducers/dialogReducer';
import strings from '../../../localization';
import EditedFieldsModal from '../../../components/Admin/Profile/Pharmacist/PharmacistViewProfile/EditedFieldsModal';

const useEditedFieldsDialog = (userType?: HelpTypes | null) => {
  const dispatch = useAppDispatch();
  const isTechnician = `${userType}` === HelpTypes.technicians;

  const handleOpenEditedFields = useCallback(
    (editedProps: string[]) => {
      dispatch(
        setDialog({
          Component: (
            <EditedFieldsModal
              editedProps={editedProps}
              isTechnician={isTechnician}
            />
          ),
          heading: {
            title: strings.fieldsEdited,
          },
          showCloseButton: true,
          maxWidth: 'xs',
        }),
      );
    },
    [dispatch, isTechnician],
  );

  return { handleOpenEditedFields };
};

export default useEditedFieldsDialog;
